import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import StatBar from '~/components/StatBar/StatBar';

const formatName = str => str.replace(/(p|P)ercentage/g, '(%)');
class SeasonStats extends React.Component {
  parseStats() {
    const teamStats = [];
    this.props.stats.forEach(stat => {
      const statFloat = stat.value ? parseFloat(stat.value) : parseFloat(stat.percentage);

      teamStats.push({ name: stat.name, value: statFloat, rank: stat.rank });
    });

    return teamStats;
  }

  parseLeagueComparison() {
    const leagueComp = [];
    this.props.stats.forEach(stat => {
      const statFloat = stat.value ? parseFloat(stat.value) : 0;
      const leagueStat = stat.percentage === 0 ? 0 : statFloat / stat.percentage * 100 - statFloat;
      leagueComp.push({ name: stat.name, value: leagueStat, rank: null });
    });

    return leagueComp;
  }

  render() {
    const stats = this.parseStats();
    const leagueComp = this.parseLeagueComparison();
    return (
      <Fragment>
        {stats.map((stat, i) => (
          <StatBar
            key={stat.name}
            team1Stat={stat.value}
            team1Percent={stat.value}
            team2Stat={leagueComp[i].value}
            team2Percent={leagueComp[i].value}
            team1Rank={stat.rank}
            statName={formatName(stat.name)}
            type="season"
          />
        ))}
      </Fragment>
    );
  }
}

SeasonStats.displayName = 'SeasonStats';

SeasonStats.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      rank: PropTypes.string.isRequired,
      value: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default SeasonStats;
